import React, { Component } from "react";
import { Link } from "react-router-dom";
import { signin } from "../helpers/auth";

import ExtendedNav from "./ExtendedNav"

export default class LoginLocked extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      email: "",
      password: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ error: "" });
    try {
      await signin(this.state.email, this.state.password);
    } catch (error) {
      this.setState({ error: error.message });
    }
  }

  render() {
    return (
      <div>
      <ExtendedNav/>
      <section>
      {/*<hr/>*/}
      <div style={{textAlign:"center"}}>
      <section>
        <form
          autoComplete="off"
          onSubmit={this.handleSubmit}
        >
          <h1>
            Login
          </h1>
          {/*<p>
            Fill in the form below to login to your account.
          </p>*/}
          <div>
            <input
              placeholder="Email"
              name="email"
              type="email"
              onChange={this.handleChange}
              value={this.state.email}
              className="inputBox"
            />
          </div>
          <div>
            <input
              placeholder="Password"
              name="password"
              onChange={this.handleChange}
              value={this.state.password}
              type="password"
              className="inputBox"
            />
          </div>
          <div>
            {this.state.error ? (
              <p>{this.state.error}</p>
            ) : null}
            <button type="submit" className="btn extra auth">Login</button>
          </div>
          {/*<hr/>*/}
        </form>
      </section>
      </div>
      {/*<GoldPageEditorsNoteSubscribe database={"editorsnote"} />*/}
      {/*<hr/>*/}
      </section>
      </div>
    );
  }
}
